// extracted by mini-css-extract-plugin
module.exports = {"main":"ModalWindow_main__VhTRh","title":"ModalWindow_title__3M09C","closeButton":"ModalWindow_closeButton__nzinK"};